import { Link as GatsbyLink } from "gatsby";
import React from "react";
import { Box, Button, Heading, Link, Flex, useColorMode } from "theme-ui";

export const Header = ({ siteTitle, siteDescription }) => {
  const [colorMode, setColorMode] = useColorMode();
  return (
    <Box as="header" sx={{ bg: "muted", mb: "1.45rem" }}>
      <Box
        as="div"
        sx={{
          m: "0 auto",
          maxWidth: "min(1400px, 80%)",
          p: "1.45rem 1.0875rem",
        }}
      >
        <Flex>
          <Box sx={{ flex: "1 1 auto", flexDirection: "column" }}>
            <Link as={GatsbyLink} to="/">
              <Heading>{siteTitle}</Heading>
            </Link>
            <Box as="p" variant="styles.p">
              {siteDescription}
            </Box>
          </Box>
          <Button
            sx={{ bg: "background", color: "text" }}
            onClick={() => {
              setColorMode(colorMode === "default" ? "dark" : "default");
            }}
          >
            {colorMode === "default" ? "Dark" : "Light"}
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};
